var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCopyOutline = function SvgCopyOutline(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 15.6C3.81 15.6 3 14.79 3 13.8V4.8C3 3.81 3.81 3 4.8 3H13.8C14.79 3 15.6 3.81 15.6 4.8M10.2 8.4H19.2C20.1941 8.4 21 9.20589 21 10.2V19.2C21 20.1941 20.1941 21 19.2 21H10.2C9.20589 21 8.4 20.1941 8.4 19.2V10.2C8.4 9.20589 9.20589 8.4 10.2 8.4Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCopyOutline);
export { ForwardRef as ReactComponent };